import { useState, useEffect } from 'react';

const useScreenSize = () => {

    const getZoomLevel = () => Math.round(window.devicePixelRatio * 100);

    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth <= 599,
        isTablet: window.innerWidth > 599 && window.innerWidth <= 899,
        isLaptop: window.innerWidth > 899 && window.innerWidth <= 1440,
        isDesktop: window.innerWidth > 1440, 
        zoomLevel: getZoomLevel(),
    });

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setScreenSize({
                width,
                height: window.innerHeight,
                isMobile: width <= 599,
                isTablet: width >599 && width <=899,
                isLaptop: width >899 && width <= 1440,
                isDesktop: width > 1440,
                zoomLevel: getZoomLevel(),
            });
        };

        window.addEventListener('resize', handleResize);

        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return screenSize;
};

export default useScreenSize;
